import React, { useState } from "react";
import { cellRendererCheck, currencyFormat, dateFormate } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import Loader from "components/Loader";
import useAxios from "hooks/useAxios";

const PurchaseHistory = (props) => {
  const {
    ndcPurchaseHistoryData,
    loading,
    ndcPurchaseHistoryRecords,
    setNdcPurchaseHistoryRecords,
    selectedndcpurchaseData,
    setSelectedNdcPurchaseData,
    MapingHistoryinstialValues,
    setNdcPurchaseHistoryData,
    setLoading,
    orgId,
  } = props;
  const API = useAxios();
  //  const [tableData,setTableData]=useState([])
  let mainCol = [
        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.accountType),
        },
        {
            dataField: 'invoicedDate',
            text: 'Invoiced Date',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => dateFormate(row.invoicedDate),
        },
        {
            dataField: 'wholesaler',
            text: 'Wholesaler',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.wholesaler),
        },
        {
            dataField: 'poid',
            text: 'POID',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.poid),
        },
        {
            dataField: 'invoicedQty',
            text: 'Invoiced Qty',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.invoicedQty),
        },
        {
            dataField: 'pkgPrice',
            text: 'Pkg Price',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.pkgPrice),
        },
        {
            dataField: 'totalPrice',
            text: 'Total Price',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.totalPrice),

        },
    ];

  // let mainCol = [
  //   {
  //     dataField: "edit",
  //     text: "Options",
  //     //cellRenderer: (rowData) => cellRenderEdit(rowData),
  //     width: 100,
  //     show: true,
  //     disabled: true,
  //     hideColFilter: true,
  //     action: true,
  //   },
  //   {
  //     dataField: "poNumber",
  //     text: "PO Number",
  //     sort: false,
  //     width: 140,
  //     show: true,
  //     inputType: "text",
  //     hideColFilter: false,
  //     cellRenderer: (row) => cellRendererCheck(row.poNumber),
  //   },
  //   {
  //     dataField: "filePONumber",
  //     text: "Source PO",
  //     sort: false,
  //     width: 200,
  //     show: true,
  //     inputType: "text",
  //     hideColFilter: false,
  //     cellRenderer: (row) => cellRendererCheck(row.filePONumber),
  //   },
  //   {
  //     dataField: "packages",
  //     text: "Hospital Name",
  //     sort: false,
  //     width: 180,
  //     show: true,
  //     inputType: "text",
  //     hideColFilter: false,
  //     cellRenderer: (row) => cellRendererCheck(row.packages),
  //   },

  //   {
  //     dataField: "accountType",
  //     text: "Account Type",
  //     sort: false,
  //     width: 140,
  //     show: true,
  //     inputType: "text",
  //     hideColFilter: false,
  //     cellRenderer: (row) =>
  //       cellRendererCheck(
  //         row.accountType == 1000
  //           ? "pending"
  //           : row.accountType == 1001
  //           ? "340B"
  //           : row.accountType == 1002
  //           ? "GPO"
  //           : "WAC"
  //       ),
  //   },
  //   {
  //     dataField: "accountCode",
  //     text: "Account #",
  //     sort: false,
  //     width: 140,
  //     show: true,
  //     edit: true,
  //     inputType: "number",
  //     hideColFilter: false,
  //     cellRenderer: (row, col) => cellRendererCheck(row.accountCode),
  //   },
  //   {
  //     dataField: "poDate",
  //     text: "PO Date",
  //     sort: false,
  //     width: 140,
  //     show: true,
  //     inputType: "date",
  //     hideColFilter: false,
  //     cellRenderer: (row) => dateFormate(row.poDate),
  //   },
  //   // {
  //   //   dataField: "mrn",
  //   //   text: "Po Type",
  //   //   sort:false,
  //   //   width: 140,
  //   //   show: true,
  //   //   inputType: "text",
  //   //   hideColFilter: false,
  //   //   cellRenderer: (row) => cellRendererCheck(row.mrn),
  //   // },
  //   {
  //     dataField: "poStatus",
  //     text: "PO Status",
  //     sort: false,
  //     width: 140,
  //     show: true,
  //     inputType: "text",
  //     hideColFilter: false,
  //     cellRenderer: (row) => cellRendererCheck(row.poStatus),
  //   },
  //   {
  //     dataField: "wholesalerName",
  //     text: "Wholesaler Name",
  //     sort: false,
  //     width: 140,
  //     show: true,
  //     inputType: "text",
  //     hideColFilter: false,
  //     cellRenderer: (row) => cellRendererCheck(row.wholesalerName),
  //   },
  //   {
  //     dataField: "totalOrdPrice",
  //     text: "Ordered Price",
  //     sort: false,
  //     width: 140,
  //     show: true,
  //     inputType: "text",
  //     hideColFilter: false,
  //     cellRenderer: (row) => cellRendererCheck(row.totalOrdPrice),
  //   },
  //   {
  //     dataField: "totalInvoicedPrice",
  //     text: "Invoiced Price",
  //     sort: false,
  //     width: 140,
  //     show: true,
  //     inputType: "text",
  //     hideColFilter: false,
  //     cellRenderer: (row) => cellRendererCheck(row.totalInvoicedPrice),
  //   },
  // ];
  const fetchPurchaseHistory = async (selectedndcpurchaseData) => {
    let ndc = selectedndcpurchaseData?.ndc;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId?.tenantID}/Crosswalk/NDCItemHistory/${ndc}`,
        MapingHistoryinstialValues,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setNdcPurchaseHistoryData(data.items);
        setNdcPurchaseHistoryRecords(data.totalRecords);
        setLoading(false);
      } else {
        setNdcPurchaseHistoryData([]);
        setNdcPurchaseHistoryRecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    debugger;
    purchaseHistoryinstialValues.currentPage = cloneDeep(filter.currentPage);
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(purchaseHistoryinstialValues);
    }
  };
  const onPageChange = (filter, haveColFilter) => {
    debugger;
    if (haveColFilter) {
      const filterObj = cloneDeep(MapingHistoryinstialValues);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      debugger;
      fetchPurchaseHistory(selectedndcpurchaseData);
    } else {
      debugger;
      MapingHistoryinstialValues.currentPage = filter.currentPage;
      MapingHistoryinstialValues.pageSize = filter.pageSize;
      fetchPurchaseHistory(selectedndcpurchaseData);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };
  return (
    <div>
      {/* {loading && <Loader opacity={0.01} />} */}
      <div>
        <h3 className="f-16 font-weight-600" style={{ color: "#702C62" }}>
          Purchase History ({ndcPurchaseHistoryRecords})
        </h3>
      </div>
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          ndcPurchaseHistoryData?.length > 0 ? "fixed-height" : "default"
        }
      >
        <ReactStrapTable
          id="crosswalkpurchasehistory"
          height={550}
          fixedColumn
          width={1200}
          data={ndcPurchaseHistoryData}
          hasPagination
          columns={mainCol}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          filters={MapingHistoryinstialValues}
          totalRecords={ndcPurchaseHistoryRecords}
          pageSize={MapingHistoryinstialValues.pageSize}
          currentPage={MapingHistoryinstialValues.currentPage}
          hidefilter={true}
        />
      </div>
    </div>
  );
};

export default PurchaseHistory;
